
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireecd3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireecd3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $5b07c6f6d765b250$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["8RPUk","thick-of-it.7f99c869.js","e1Zts","the-screen.60e45618.avif","fvhrz","the-ring.927709ab.webp","1IwIo","pen.577b5bc9.jpg","83hZv","the-king.d02b3610.avif","sr7m2","3dgifmaker53230.dc81fc0a.gif","eHqwL","skeet.68030d3b.png"]'));

var $c0913d1184ae2f07$exports = {};
$c0913d1184ae2f07$exports = new URL("the-screen.60e45618.avif", import.meta.url).toString();


var $e9515a2fd754b584$exports = {};
$e9515a2fd754b584$exports = new URL("the-ring.927709ab.webp", import.meta.url).toString();


var $78dfe977aa5b32ba$exports = {};
$78dfe977aa5b32ba$exports = new URL("pen.577b5bc9.jpg", import.meta.url).toString();


var $f44761e9f00eb1a6$exports = {};
$f44761e9f00eb1a6$exports = new URL("the-king.d02b3610.avif", import.meta.url).toString();


var $bb688419007eb4a6$exports = {};
$bb688419007eb4a6$exports = new URL("3dgifmaker53230.dc81fc0a.gif", import.meta.url).toString();


var $d19d1768b36b474a$exports = {};
$d19d1768b36b474a$exports = new URL("skeet.68030d3b.png", import.meta.url).toString();


"use strict";
document.addEventListener("DOMContentLoaded", function() {
    const video = document.getElementById("thickOfItVideo");
    const skeet = document.querySelector(".skeet");
    const skeetKey = skeet.getAttribute("data-bg");
    video.removeAttribute("controls");
    video.playbackRate = 1;
    window.addEventListener("click", ()=>{
        video.play();
    });
    const loadingScreen = document.querySelector(".loading-screen");
    video.addEventListener("loadeddata", ()=>{
        loadingScreen.style.display = "none";
        loadImages();
    });
    video.load();
    let audioContext;
    window.addEventListener("click", ()=>{
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const source = audioContext.createMediaElementSource(video);
        const distortion1 = audioContext.createWaveShaper();
        distortion1.curve = makeDistortionCurve(0);
        distortion1.oversample = "4x";
        source.connect(distortion1);
        distortion1.connect(audioContext.destination);
    });
    function makeDistortionCurve(amount) {
        const n_samples = 44100;
        const curve = new Float32Array(n_samples);
        const deg = Math.PI / 180;
        for(let i = 0; i < n_samples; ++i){
            const x = i * 2 / n_samples - 1;
            curve[i] = (3 + amount) * x * 20 * deg / (Math.PI + amount * Math.abs(x));
        }
        return curve;
    }
    let clickCount = 0;
    video.addEventListener("click", function() {
        clickCount++;
        console.log(clickCount);
        const distortionAmount = clickCount * 10;
        video.playbackRate += 0.01;
        distortion.curve = makeDistortionCurve(distortionAmount);
    });
    function rotationForClick() {
        let deg = 1;
        console.log(window.innerWidth);
        document.querySelectorAll(".grid-item-inner").forEach((item)=>{
            item.addEventListener("click", ()=>{
                item.style.transform = `rotateY(${180 * deg}deg)`;
                deg++;
                if (deg === 3) deg = 1;
            });
        });
    }
    if (window.innerWidth <= 768) rotationForClick();
    //intersection observer
    function loadImages() {
        const images = {
            screenImg: (0, (/*@__PURE__*/$parcel$interopDefault($c0913d1184ae2f07$exports))),
            ringImg: (0, (/*@__PURE__*/$parcel$interopDefault($e9515a2fd754b584$exports))),
            penImg: (0, (/*@__PURE__*/$parcel$interopDefault($78dfe977aa5b32ba$exports))),
            kingImg: (0, (/*@__PURE__*/$parcel$interopDefault($f44761e9f00eb1a6$exports))),
            skeetImg: (0, (/*@__PURE__*/$parcel$interopDefault($d19d1768b36b474a$exports))),
            spinImg: (0, (/*@__PURE__*/$parcel$interopDefault($bb688419007eb4a6$exports)))
        };
        const lazyLoad = document.querySelectorAll(".grid-item-back, .skeet, .spinny-gif");
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    //   console.log(entry.target);
                    const imgElement = entry.target;
                    console.log(imgElement);
                    const backgroundImage = imgElement.getAttribute("data-bg");
                    const imgSrc = images[backgroundImage];
                    //   console.log(backgroundImage);
                    if (!imgElement.classList.contains("spinny-gif")) imgElement.style.backgroundImage = `url(${imgSrc})`;
                    else {
                        console.log("yes");
                        // console.log(src);
                        imgElement.src = imgSrc;
                    }
                    // imgElement.style.backgroundColor = `black`;
                    observer.unobserve(imgElement);
                }
            });
        });
        lazyLoad.forEach((image)=>{
            observer.observe(image);
        });
    }
// skeet.style.backgroundImage = `url(${images[skeetKey]})`;
});


//# sourceMappingURL=thick-of-it.7f99c869.js.map
